import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { MainLayout } from './components/layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import {
  LoginPage, RegisterPage, ForgotPasswordPage,
  DashboardPage, SourcesPage, SourceDetailPage,
  FeedPage, ClustersPage, ClusterDetailPage,
  ArticlesPage, ArticleDetailPage,
  ApiKeysPage, UsersPage, SettingsPage, JobsPage, ActivityPage,
} from './pages';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />

          {/* Protected routes */}
          <Route path="/" element={<ProtectedRoute><MainLayout title="Dashboard"><DashboardPage /></MainLayout></ProtectedRoute>} />
          <Route path="/sources" element={<ProtectedRoute><MainLayout title="Sources"><SourcesPage /></MainLayout></ProtectedRoute>} />
          <Route path="/sources/:id" element={<ProtectedRoute><MainLayout><SourceDetailPage /></MainLayout></ProtectedRoute>} />
          <Route path="/feed" element={<ProtectedRoute><MainLayout title="Incoming Feed"><FeedPage /></MainLayout></ProtectedRoute>} />
          <Route path="/clusters" element={<ProtectedRoute><MainLayout title="Story Clusters"><ClustersPage /></MainLayout></ProtectedRoute>} />
          <Route path="/clusters/:id" element={<ProtectedRoute><MainLayout><ClusterDetailPage /></MainLayout></ProtectedRoute>} />
          <Route path="/articles" element={<ProtectedRoute><MainLayout title="Generated Articles"><ArticlesPage /></MainLayout></ProtectedRoute>} />
          <Route path="/articles/:id" element={<ProtectedRoute><MainLayout><ArticleDetailPage /></MainLayout></ProtectedRoute>} />

          {/* Admin routes */}
          <Route path="/api-keys" element={<ProtectedRoute requiredRole="admin"><MainLayout title="API Keys"><ApiKeysPage /></MainLayout></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute requiredRole="admin"><MainLayout title="Users & Roles"><UsersPage /></MainLayout></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute requiredRole="admin"><MainLayout title="Settings"><SettingsPage /></MainLayout></ProtectedRoute>} />
          <Route path="/jobs" element={<ProtectedRoute requiredRole="admin"><MainLayout title="Jobs Queue"><JobsPage /></MainLayout></ProtectedRoute>} />
          <Route path="/activity" element={<ProtectedRoute requiredRole="admin"><MainLayout title="Activity Log"><ActivityPage /></MainLayout></ProtectedRoute>} />

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
